import { render } from "./BookOverviewComponent.vue?vue&type=template&id=6ff53c88&scoped=true"
const script = {}

import "./BookOverviewComponent.vue?vue&type=style&index=0&id=6ff53c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff53c88"]])

export default __exports__